import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '@env/environment';
@Injectable({ providedIn: 'root' })
export class MonitoringService {
  private appInsights = new ApplicationInsights({
    config: {
      connectionString: environment.appInsightsConnectionString,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
    },
  });
  constructor() {
    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView();
  }
  trackEvent(name: string, properties?: Record<string, unknown>) {
    this.appInsights.trackEvent({ name }, properties);
  }
  trackError(error: Error, properties?: Record<string, unknown>) {
    this.appInsights.trackException({ exception: error }, properties);
  }
  setUser(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }
  clearUser() {
    this.appInsights.clearAuthenticatedUserContext();
  }
}
